import React from 'react';
import type { ValidationStatus } from './types';
import { useSound } from '../sounds';

export interface RadioOptionsProps {
  name: string;
  options: string[];
  value: string;
  validationStatus?: ValidationStatus;
  onChange: (name: string, value: string) => void;
}

/**
 * Radio options widget - displays single-choice radio buttons
 * Only one option can be selected at a time
 */
export const RadioOptions: React.FC<RadioOptionsProps> = ({
  name,
  options,
  value,
  validationStatus = null,
  onChange,
}) => {
  const playSound = useSound();
  return (
    <div className="radio-options">
      {options.map((option, idx) => {
        const isSelected = value === option;
        const statusClass = isSelected && validationStatus ? ` widget--${validationStatus}` : '';

        return (
          <button
            key={`${name}-radio-${idx}`}
            className={`radio-option${isSelected ? ' selected' : ''}${statusClass}`}
            onClick={() => { playSound('radio-select'); onChange(name, option); }}
            type="button"
          >
            {option}
          </button>
        );
      })}
    </div>
  );
};
